/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionLanguageEnum } from './InformationExtractionLanguageEnum';
import {
  InformationExtractionLanguageEnumFromJSON,
  InformationExtractionLanguageEnumFromJSONTyped,
  InformationExtractionLanguageEnumToJSON,
} from './InformationExtractionLanguageEnum';

/**
 *
 * @export
 * @interface InformationExtractionGenerationInputsCreate
 */
export interface InformationExtractionGenerationInputsCreate {
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputsCreate
   */
  readonly id: number;
  /**
   *
   * @type {InformationExtractionLanguageEnum}
   * @memberof InformationExtractionGenerationInputsCreate
   */
  language?: InformationExtractionLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputsCreate
   */
  minNumSamples?: number;
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputsCreate
   */
  maxNumAttempts?: number;
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputsCreate
   */
  maxWorkers?: number;
  /**
   *
   * @type {boolean}
   * @memberof InformationExtractionGenerationInputsCreate
   */
  verifySamples?: boolean;
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputsCreate
   */
  seedDocuments: number;
}

/**
 * Check if a given object implements the InformationExtractionGenerationInputsCreate interface.
 */
export function instanceOfInformationExtractionGenerationInputsCreate(
  value: object,
): value is InformationExtractionGenerationInputsCreate {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('seedDocuments' in value) || value['seedDocuments'] === undefined) return false;
  return true;
}

export function InformationExtractionGenerationInputsCreateFromJSON(
  json: any,
): InformationExtractionGenerationInputsCreate {
  return InformationExtractionGenerationInputsCreateFromJSONTyped(json, false);
}

export function InformationExtractionGenerationInputsCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionGenerationInputsCreate {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    language: json['language'] == null ? undefined : InformationExtractionLanguageEnumFromJSON(json['language']),
    minNumSamples: json['min_num_samples'] == null ? undefined : json['min_num_samples'],
    maxNumAttempts: json['max_num_attempts'] == null ? undefined : json['max_num_attempts'],
    maxWorkers: json['max_workers'] == null ? undefined : json['max_workers'],
    verifySamples: json['verify_samples'] == null ? undefined : json['verify_samples'],
    seedDocuments: json['seed_documents'],
  };
}

export function InformationExtractionGenerationInputsCreateToJSON(
  value?: Omit<InformationExtractionGenerationInputsCreate, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    language: InformationExtractionLanguageEnumToJSON(value['language']),
    min_num_samples: value['minNumSamples'],
    max_num_attempts: value['maxNumAttempts'],
    max_workers: value['maxWorkers'],
    verify_samples: value['verifySamples'],
    seed_documents: value['seedDocuments'],
  };
}
